import { render, staticRenderFns } from "./UserApproveList.vue?vue&type=template&id=759e825c&"
import script from "./UserApproveList.vue?vue&type=script&lang=js&"
export * from "./UserApproveList.vue?vue&type=script&lang=js&"
import style0 from "./UserApproveList.vue?vue&type=style&index=0&id=759e825c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports